import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormlyContractDurationComponent} from './contract-duration.component';
import {FormlyModule} from '@ngx-formly/core';
import {I18nModule} from '@spartacus/core';
import {RadioGroupModule} from 'ng-design-system';
import {ReactiveFormsModule} from '@angular/forms';


@NgModule({
  declarations: [FormlyContractDurationComponent],
  imports: [
    I18nModule,
    CommonModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'contract-duration',
          component: FormlyContractDurationComponent
        },
      ],
    }),
    RadioGroupModule,
    ReactiveFormsModule,
  ]
})
export class FormlyContractDurationModule {
}
